// Message catalogues reused verbatim from the Next.js app. use-intl consumes
// the same JSON shape as next-intl, so these port unchanged.

import type { Locale } from '@/features/locale/supported-languages';
import de from '@/messages/de.json';
import dk from '@/messages/dk.json';
import en from '@/messages/en.json';
import fi from '@/messages/fi.json';
import fr from '@/messages/fr.json';
import no from '@/messages/no.json';
import pl from '@/messages/pl.json';
import pt from '@/messages/pt.json';
import sv from '@/messages/sv.json';

export type Messages = typeof en;

export const messages: Record<Locale, Messages> = {
  en,
  sv,
  no,
  dk,
  de,
  fr,
  fi,
  pt,
  pl,
} as Record<Locale, Messages>;
